// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05d88e20","453":"caa1b626","455":"01bd748d","977":"4c8e35ba"}[chunkId] + ".chunk.js";
};